import { format as formatDate } from 'date-fns';

import { ViewMode } from '@web/forms/components/datePicker/datePicker.types';
import {
  Header,
  ArrowButton,
  LeftArrowIcon,
  RightArrowIcon,
  DatepickerTitle,
  DatepickerTitleText,
} from '@web/forms/components/datePicker/DatePickerCustomHeader/datePickerCustomHeader.styles';

const DatePickerCustomHeader = ({
  date,
  increaseMonth,
  decreaseMonth,
  increaseYear,
  decreaseYear,
  viewMode,
  setViewMode,
  withoutYearPicker,
}) => {
  const onLeftArrowClick = () => {
    if (viewMode === ViewMode.day) {
      return void decreaseMonth();
    }

    decreaseYear();
  };

  const onRightArrowClick = () => {
    if (viewMode === ViewMode.day) {
      return void increaseMonth();
    }

    increaseYear();
  };

  const onDatepickerTitleClick = () => {
    if (viewMode === ViewMode.day) {
      setViewMode(ViewMode.month);
    } else if (viewMode === ViewMode.month && !withoutYearPicker) {
      setViewMode(ViewMode.year);
    } else if (viewMode === ViewMode.year) {
      setViewMode(ViewMode.day);
    }
  };

  let datepickerTitle: string;
  if (viewMode === ViewMode.day) {
    datepickerTitle = formatDate(date, 'MMMM yyyy');
  } else if (viewMode === ViewMode.month) {
    datepickerTitle = formatDate(date, 'yyyy');
  } else {
    /**
     * The year picker arrangement is always 12 years on one screen
     * The year 2005 if always the first one in one of the ranges
     * so we can figure out what years are visible based on that.
     */
    const currentYear = date.getFullYear();
    const offset = (currentYear - 2005) % 12;
    const firstVisibleYear = currentYear - offset;
    const lastVisibleYear = firstVisibleYear + 11;
    datepickerTitle = `${firstVisibleYear} - ${lastVisibleYear}`;
  }

  return (
    <Header>
      <ArrowButton onClick={onLeftArrowClick}>
        <LeftArrowIcon />
      </ArrowButton>
      <DatepickerTitle onClick={onDatepickerTitleClick}>
        <DatepickerTitleText>{datepickerTitle}</DatepickerTitleText>
      </DatepickerTitle>
      <ArrowButton onClick={onRightArrowClick}>
        <RightArrowIcon />
      </ArrowButton>
    </Header>
  );
};

export default DatePickerCustomHeader;
